<!-- EditClassroomPage.vue: 教室情報の操作を行うページ -->
<template lang="html">
  <div id="editClassroomPage">
    <p class="schoolTab">
    </p>
    <table id="userPartnerList">
      <caption>教室の情報を変更します．</caption>
      <thead>
        <tr>
          <th>
            ID
          </th>
          <th>教室名</th>
          <th>削除</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(classroom, index) in $store.state.classrooms" :key="classroom.id"
        :class="{ evenRow: index % 2 === 0 }" v-if="classroom.school_id == $store.state.userInfo.school_id">
        <td>{{ classroom.id }}</td>
        <td v-if="editingId !== classroom.id" @dblclick="startEditClassroom(classroom.id)">
          <pre class="classroom-name">{{ classroom.name }}</pre>
        </td>
        <td v-else>
          <textarea v-model="editingClassroomName" rows="3"></textarea>
          <button @click="editClassroomName()">変更</button>
          <button @click="cancelEdit">キャンセル</button>
        </td>
        <td><button @click="eraseClassroom(classroom)">x</button></td>
      </tr>
      <tr>
       <td>教室を追加する</td>
       <td><textarea  placeholder="教室名を入力してください"
         v-model="classroomName"></textarea></td>
       <td><button @click="addClassroom()">追加</button></td>
      </tr>
    </tbody>
  </table>

  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
export default {
  data () {
    return {
      classroomName: '',
      classroomid: 1,
      editingId: null,
      editingClassroomName: '',
      originalEditingName: ''
    }
  },
  methods: {
    ...mapActions([
      'deleteClassroom',
      'createClassroom',
      'getClassrooms',
      'editClassroom'
    ]),
    eraseClassroom (classroom) {
      this.deleteClassroom(classroom.id).then((res) => {
        this.getClassrooms(this.$store.state.userInfo.school_id)
      })
    },
    addClassroom () {
      if (this.classroomName === '') {
        alert('教室名を入力してください')
        return
      }
      this.classroomid = this.$store.state.userInfo.school_id
      this.createClassroom({
        name: this.classroomName, school_id: this.classroomid
      }).then(() => {
        this.getClassrooms(this.$store.state.userInfo.school_id)
      }).then(() => {
        console.log(this.$store.state.classrooms)
        this.classroomName = ''
      })
    },
    editClassroomName () {
      if (!this.editingId) {
        alert('編集中の教室はありません')
        return
      }
      if (this.editingClassroomName === '') {
        alert('教室名を入力してください')
        return
      }
      this.classroomid = this.editingId
      this.editClassroom({
        name: this.editingClassroomName, classroom_id: this.editingId
      }).then(() => {
        this.getClassrooms(this.$store.state.userInfo.school_id)
      }).then(() => {
        console.log(this.$store.state.classrooms)
        this.editingId = null
        this.editClassroomName = ''
      })
    },
    startEditClassroom (id) {
      // 編集モードに切り替え、対象の教室名をセット
      this.editingId = id
      const classroom = this.$store.state.classrooms.find(c => c.id === id)
      this.editingClassroomName = classroom.name
      this.originalName = classroom.name
    },
    cancelEdit () {
      // 編集をキャンセルし、元の名前に戻して編集モードを終了
      this.editingClassroomName = this.originalEditingName
      this.editingId = null
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 50%;
  margin: auto;
}
.evenRow {
  background-color: #ffffcc
}
table tr:hover {
  background-color: #ffcccc
}
.schoolTab a{
  font-size: 20px;
  margin: 5px;
  background-color: rgba(141, 143, 159, 0.48);
  border-radius: 5px;
}
.selected{
  border-bottom: solid 5px rgba(72, 200, 139, 0.52);
}
.classroom-name {
  font-size: 16px; /* 通常のフォントサイズに設定 */
  line-height: 1.5; /* 行間を適度に広くする */
  padding: 5px; /* <pre>タグに少し余白を追加 */
  white-space: pre-wrap; /* 改行を保持しつつ、折り返しも行う */
}
</style>



// WEBPACK FOOTER //
// EditClassroomPage.vue?06165eb7